import React from "react";
import { DeviceLimitInfoModalTemplate } from "themes/application/payment/components";

function DeviceLimitInfoModal(props) {
    return <DeviceLimitInfoModalTemplate {...props} />;
}

export default DeviceLimitInfoModal;
